
export const SSO_CHECK_COOLDOWN_MS = 60_000;

export function hasOidcCallback(search: string, hash: string): boolean {
  return /[?#&](code|error|session_state|state)=/.test(`${search}${hash}`);
}

export interface RedirectCheckInput {
  search: string;
  hash: string;
  revoked: boolean;
  hasStoredSession: boolean;
  lastCheckAt: number;
  now: number;
}

export function shouldRedirectCheckSso(input: RedirectCheckInput): boolean {
  if (input.hasStoredSession) return false;
  if (input.revoked) return false;
  if (hasOidcCallback(input.search, input.hash)) return false;
  if (input.lastCheckAt > 0 && input.now - input.lastCheckAt < SSO_CHECK_COOLDOWN_MS) return false;
  return true;
}

export function ssoReturnPathFor(pathname: string, search: string, hash: string): string | null {
  if (pathname === '/' || pathname === '/login') return null;
  return `${pathname}${search}${hash}`;
}
